/* eslint-disable react/prop-types */
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { IMAGE_URL } from "../../constants";

export default function ZUMSAdmin({ data, title }) {
  const filteredData = data?.filter((person) =>
    title === "Leader" ? person.is_leader === 1 : person.is_leader === 0,
  );

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4"
          >
            Meet Our {title}s
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {filteredData?.map((person, index) => (
            <AdminCard key={person.id} person={person} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

function AdminCard({ person, index }) {
  const [expanded, setExpanded] = useState(false);

  const hasManyProjects = person.projects?.length > 3;
  const visibleProjects = expanded
    ? person.projects
    : person.projects?.slice(0, 2);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition text-center"
    >
      <img
        src={`${IMAGE_URL}/${person.image}`}
        alt={person.name}
        className="w-full aspect-square max-h-56 h-full mx-auto mb-4 object-top object-cover"
      />

      <div className="p-6">
        <h3 className="text-lg font-semibold text-gray-900">{person.name}</h3>
        <p className="text-sm text-gray-500">
          {person.department}, {person.session}
        </p>
        <p className="text-sm text-gray-700 mt-2">{person.designation}</p>

        {/* Projects */}
        {person.projects?.length > 0 && (
          <div className="mt-4 text-left">
            <h4 className="text-sm font-semibold text-gray-800 mb-2">
              Projects:
            </h4>

            <motion.ul
              layout
              className="list-disc list-inside text-sm text-gray-600 space-y-1 overflow-hidden"
            >
              <AnimatePresence>
                {visibleProjects.map((project) => (
                  <motion.li
                    key={project.id}
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    {project.link ? (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary-600 hover:underline"
                      >
                        {project.name}
                      </a>
                    ) : (
                      project.name
                    )}
                  </motion.li>
                ))}
              </AnimatePresence>
            </motion.ul>

            {/* See More / Less Button */}
            {hasManyProjects && (
              <button
                onClick={() => setExpanded(!expanded)}
                className="mt-2 text-sm font-medium text-primary-600 hover:underline"
              >
                {expanded ? "See less" : "See more"}
              </button>
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
}
